import React, {useState} from 'react';
import '../styles/ResearcherPage.css';
import {ResearchHeaderConnector} from "../connectors/ResearchHeaderConnector";
import {useDispatch} from "react-redux";
import {SET_USER_AS_RESEARCHER} from "../action-lists";

export const ResearcherPage = (props) => {
    const [verified, setVerified] = useState(props.isResearcher);
    const dispatch = useDispatch();

    const handleOnChange = (e) => {
        if (e.target.value === 'fakeresearch') {
            setVerified(true);
            dispatch({
                isResearcher: true,
                type: SET_USER_AS_RESEARCHER
            })
        }
    }

    return (
        <div className='researcher-page-container'>
            {
                verified ?
                    <>
                        <ResearchHeaderConnector/>
                    </> :
                    <div className='verification-container'>
                        <h5>Please enter verification code to proceed</h5>
                        <input type='password' onChange={handleOnChange} className='verification-code'/>
                    </div>
            }
        </div>
    );
}
